import { Box, styled } from '@mui/material';

// Contenido del panel de navegación (desktop y mobile): columna a altura completa;
// la zona de menú (StyledSidebarNavZone) es la única que scrollea.
const StyledSidebarPanel = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
  padding: '18px 14px 12px'
}));

export default StyledSidebarPanel;
